<template>
	<v-dialog
			:value="isViewSchedule"
			content-class="dialogWrapper"
			fullscreen
			hide-overlay
			transition="dialog-bottom-transition"
	>
		<div class="dialogWrap">
			<div class="dialogTitle">
				<span>View schedule</span>
				<button type="button" @click="onClose">
					<svg-sprite width="20" height="20" icon-id="close"></svg-sprite>
				</button>
			</div>
			<div class="dialogMain">
				<div class="fieldWrapper">
					<field
							:class-error="getError('name')"
							margin="0"
							width="100%"
							label="Name"
							placeholder="Enter name"
							:setInputValue="name"
							@updateInput="onInput($event, 'name')"
							is-required
					></field>
					<field
							overflow="hidden"
							margin="0"
							width="100%"
							padding="0"
							labelSwitch="Status schedule"
							:switch-value="statusSchedule"
							@updateSwitch="onCheckbox($event, 'statusSchedule')"
							is-dense
							is-checkbox
							is-off-style
					></field>
					<field
							overflow="hidden"
							margin="0"
							width="100%"
							padding="0"
							labelSwitch="Schedule Nightly"
							:switch-value="nightly"
							@updateSwitch="onCheckbox($event, 'nightly')"
							is-dense
							is-checkbox
							is-off-style
					></field>
					<field
							overflow="hidden"
							margin="0"
							width="100%"
							padding="0"
							labelSwitch="Xlsx"
							:switch-value="xlsx"
							@updateSwitch="onCheckbox($event, 'xlsx')"
							is-dense
							is-checkbox
							is-off-style
					></field>
					<field
							overflow="hidden"
							margin="0"
							width="100%"
							padding="0"
							labelSwitch="Default value is time"
							:switch-value="defaultTime"
							@updateSwitch="onCheckbox($event, 'defaultTime')"
							is-dense
							is-checkbox
							is-off-style
					></field>
					<field
							overflow="hidden"
							margin="0"
							width="100%"
							padding="0"
							labelSwitch="Month"
							:switch-value="work_type"
							@updateSwitch="onCheckbox($event, 'work_type')"
							is-dense
							is-checkbox
							is-off-style
					></field>
				</div>

				<div class="tableWrapper">
					<div class="workTableMain">
						<div
								v-for="weekMeta in visibleWeeksMeta"
								:key="weekMeta.key"
								class="weekWrap"
						>
							<div class="rowHead">
								<div class="dayNameHead">Day</div>
								<div class="dayInfoHead">{{ weekMeta.label }}</div>
							</div>

							<div
									v-for="(dayLabel, dayIndex) in daysShort"
									:key="dayLabel"
									class="rowLine rowDay"
							>
								<div class="dayName">{{ dayLabel }}</div>
								<div class="dayInfo">
									<input
											type="text"
											placeholder="HH:MM"
											v-mask="'##:##'"
											v-model="weeks[weekMeta.key][dayIndex][0]"
									>
									<input
											type="text"
											placeholder="HH:MM"
											v-mask="'##:##'"
											v-model="weeks[weekMeta.key][dayIndex][1]"
									>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="footer">
					<custom-btn
							text="Save"
							@updateEvent="onSave"
							custom-class="apply"
							is-all-elements
							margin="0"
							:icon-attrs="{width: 20, height: 20, iconId: 'safe'}"
					></custom-btn>
					<custom-btn
							text="Close"
							@updateEvent="onClose"
							is-all-elements
							margin="0"
							:icon-attrs="{width: 20, height: 20, iconId: 'close'}"
					></custom-btn>
				</div>
			</div>
		</div>
		<preload v-if="isPreloader"></preload>
	</v-dialog>
</template>

<script>
import Vue from 'vue';
import VueMask from 'v-mask';

// validation
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';

import { mapActions, mapGetters } from 'vuex';
import Preload from '@/shared/Preload/Preload.vue';

Vue.use(VueMask);

export default {
	name: 'ViewSchedule',
	components: { Preload },

	mixins: [ validationMixin ],

	props: {
		dialogFlag: {
			type: String,
			default: 'add',
		},
		editSchedulev: {
			type: Object,
			default: null,
		},
	},

	computed: {
		...mapGetters([
			'calendarMonthData2',
		]),

		// если work_type = true → показываем только 2 недели, иначе 4
		visibleWeeksMeta() {
			return this.work_type
				? this.weeksMeta.slice(0, 2) // две недели
				: this.weeksMeta; // все четыре недели
		},
	},

	validations: {
		name: { required },
	},

	data: () => ({
		isViewSchedule: true,

		weeks: {
			week1: [],
			week2: [],
			week3: [],
			week4: [],
		},

		daysShort: [ 'Sat', 'Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri' ],
		weeksMeta: [
			{ key: 'week1', label: 'Week #1' },
			{ key: 'week2', label: 'Week #2' },
			{ key: 'week3', label: 'Week #3' },
			{ key: 'week4', label: 'Week #4' },
		],

		name: null,
		xlsx: false,
		statusSchedule: false,
		nightly: false,
		defaultTime: false,
		work_type: false,

		idSchedule: null,
		isPreloader: false,
	}),

	created() {
		// До первого рендера заполняем недели пустыми значениями,
		// чтобы не было ошибки чтения [0] у undefined
		this.initWeeks(false);
	},

	methods: {
		...mapActions([ 'setAlert', 'onAccountScheduleSave', 'onAccountScheduleEdit' ]),

		onInput({ value }, key) {
			this[key] = value;
		},

		onClose() {
			this.$emit('updateClose');
		},

		getError(key) {
			return this.$v && this.$v[key] && this.$v[key].$error;
		},

		/*
		 * Пустая неделя: 7 дней по ["", ""]
		 */
		createEmptyWeek() {
			return Array(7)
				.fill(null)
				.map(() => [ '', '' ]);
		},

		/*
		 * Неделя с дефолтным временем
		 */
		createDefaultWeek() {
			return [
				[ '', '' ], // Sat
				[ '', '' ], // Sun
				[ '09:00', '18:00' ], // Mon
				[ '09:00', '18:00' ], // Tue
				[ '09:00', '18:00' ], // Wed
				[ '09:00', '18:00' ], // Thu
				[ '09:00', '18:00' ], // Fri
			];
		},

		/*
		 * Инициализация всех недель
		 * @param {boolean} useDefault использовать ли дефолтное время
		 */
		initWeeks(useDefault) {
			const factory = useDefault ? this.createDefaultWeek : this.createEmptyWeek;
			this.weeks.week1 = factory();
			this.weeks.week2 = factory();
			this.weeks.week3 = factory();
			this.weeks.week4 = factory();
		},

		onCheckbox({ value }, key) {
			if (key === 'defaultTime') {
				this.defaultTime = value;
				this.initWeeks(value);
				return;
			}

			this[key] = value;
		},

		async onSave() {
			this.isPreloader = true;

			this.$v.$touch();
			if (!this.$v.$error) {
				const {
					name,
					statusSchedule,
					xlsx,
					nightly,
					weeks,
				} = this;
				const {
					week1,
					week2,
					week3,
					week4,
				} = weeks;

				const work_type = Number(this.work_type);

				let values = {};

				if (work_type) {
					values = {
						name,
						statusSchedule,
						xlsx,
						nightly,
						week1,
						week2,
						work_type
					};
				} else {
					values = {
						name,
						statusSchedule,
						xlsx,
						nightly,
						week1,
						week2,
						week3,
						week4,
						work_type
					};
				}

				if (this.dialogFlag === 'add') {
					await this.onAccountScheduleSave({ values, id: this.idSchedule });
				} else {
					await this.onAccountScheduleEdit({ values, id: this.idSchedule });
				}

				this.$emit('updateClose');
				this.$emit('updateList');
			} else {
				await this.setAlert({ type: 'error', message: 'Saving error' });
			}

			this.isPreloader = false;
		},
	},

	mounted() {
		this.isPreloader = true;

		if (this.dialogFlag === 'add') {
			this.name = null;
			this.xlsx = false;
			this.statusSchedule = false;
			this.nightly = false;
			this.defaultTime = false;
			this.work_type = false;
			this.idSchedule = null;
		} else if (this.editSchedulev) {
			this.weeks.week1 = this.editSchedulev.week1 || this.createEmptyWeek();
			this.weeks.week2 = this.editSchedulev.week2 || this.createEmptyWeek();
			this.weeks.week3 = this.editSchedulev.week3 || this.createEmptyWeek();
			this.weeks.week4 = this.editSchedulev.week4 || this.createEmptyWeek();

			this.name = this.editSchedulev.name;
			this.xlsx = !!this.editSchedulev.xlsx;
			this.statusSchedule = !!this.editSchedulev.status;
			this.nightly = !!this.editSchedulev.nightly;
			this.defaultTime = !!this.editSchedulev.defaultTime;
			this.work_type = !!this.editSchedulev.work_type;
			this.idSchedule = this.editSchedulev.id;
		}

		this.isPreloader = false;
	},
};
</script>

<style scoped lang="scss">
@import '../ViewVersion/ViewVersion';
</style>
